import React from 'react';

import FormCheckbox from "core/gd-form/form-element/checkbox/checkbox";

export default function RateExperienceFeature(props) {

    const onClick = (e) => {
        e.stopPropagation();
        props.form.setValue(props.name, !props.form.getValue(props.name));
        props.reRender();
    };

    return (
        <div className="work-on" onClick={onClick}>

            <FormCheckbox className="suggestion-checkbox" form={props.form} name={props.name}/>

            {props.title}
        </div>
    );

}
